import type { IconProps } from './types';

export type ChevronIconProps = {
  direction?: 'right' | 'down' | 'left' | 'up';
} & IconProps;

export const ChevronIcon = (props: ChevronIconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
    direction = 'right',
  } = props;

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={{
        ...(direction === 'down' && { transform: 'rotate(90deg)' }),
        ...(direction === 'left' && { transform: 'rotate(180deg)' }),
        ...(direction === 'up' && { transform: 'rotate(270deg)' }),
        ...(direction === 'right' && { transform: 'rotate(0deg)' }),
      }}
      className={className}
    >
      <path
        d="M3.29927 5.8438C3.13931 5.60123 3.16586 5.27115 3.37934 5.05767C3.59282 4.84419 3.92291 4.81764 4.16548 4.97759L4.26411 5.05767L8.51899 9.31353C8.87451 9.66917 8.89671 10.2319 8.5854 10.6133L8.51899 10.6866L4.26411 14.9424L4.16548 15.0225C3.92291 15.1825 3.59282 15.1559 3.37934 14.9424C3.16586 14.729 3.13931 14.3989 3.29927 14.1563L3.37934 14.0577L7.43696 10.0001L3.37934 5.94243L3.29927 5.8438Z"
        fill={color}
      />
    </svg>
  );
};
